import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class TimerAPI extends ComponentAPI {
    getCurrentTime() {
        return this.state.time;
    }
    startTimer() {
        if (!this.state.isRunning) {
            this.setState({ isRunning: true });
        }
    }
    stopTimer() {
        this.setState({ isRunning: false });
    }
}
export default TimerAPI;
//# sourceMappingURL=timer-api.js.map